export const searchBarHeightBig = 60;
export const searchBarHeightSmall = 50;
